import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "col" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { style: {"position":"absolute","left":"20px","top":"5px","z-index":"10"} }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Datum"),
  /*#__PURE__*/_createElementVNode("th", null, "Status")
], -1)
const _hoisted_7 = {
  key: 0,
  class: "totals"
}
const _hoisted_8 = { class: "col" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Omschrijving"),
    /*#__PURE__*/_createElementVNode("th", null, "Aantal uur"),
    /*#__PURE__*/_createElementVNode("th", null, "Acties")
  ])
], -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "actions" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "Vul hier de code in die naar je emailadres is verzonden om Simplex PLNNR te activeren.", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Dagen van de week:")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Instellingen voor dagselectie:")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_VDatePicker = _resolveComponent("VDatePicker")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_btn, {
            icon: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDetacheringsDialog = true)),
            style: {"margin-right":"8px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-calendar-plus")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            icon: "",
            onClick: _ctx.toggleProjectFilter
          }, {
            default: _withCtx(() => [
              (!_ctx.projectFilterActive)
                ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-filter-variant")
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-filter-off")
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.employees && _ctx.employees.length > 0 && !_ctx.isEss && !_ctx.fromProject)
            ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                key: 0,
                class: "employee",
                label: "Kies medewerker",
                items: _ctx.employees,
                disabled: !_ctx.employees || _ctx.isEss,
                "item-title": "Naam",
                "item-value": "Medewerker",
                "onUpdate:modelValue": _ctx.onChangeEmployee,
                "auto-select-first": ""
              }, null, 8, ["items", "disabled", "onUpdate:modelValue"]))
            : _createCommentVNode("", true),
          (_ctx.projects && _ctx.projects.length > 0 && _ctx.fromProject)
            ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                key: 1,
                class: "employee",
                label: "Kies project",
                items: _ctx.projects,
                disabled: !_ctx.projects,
                "item-title": "Projectomschrijving",
                "item-value": "ProjectCode",
                "onUpdate:modelValue": _ctx.onChangeProject,
                "auto-select-first": ""
              }, null, 8, ["items", "disabled", "onUpdate:modelValue"]))
            : _createCommentVNode("", true),
          _createVNode(_component_VDatePicker, {
            color: "white",
            attributes: _ctx.filteredAttrs,
            onDayclick: _ctx.onClickDay,
            columns: _ctx.amountColumns,
            rows: _ctx.amountRows,
            showWeeknumbers: "",
            disabledDates: _ctx.disabledDates,
            step: 3
          }, null, 8, ["attributes", "onDayclick", "columns", "rows", "disabledDates"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", null, [
            _hoisted_6,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newDates, (newdate) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(newdate.description), 1),
                  (newdate.status === _ctx.Status.init)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        icon: "mdi:mdi-border-radius"
                      }))
                    : _createCommentVNode("", true),
                  (newdate.status === _ctx.Status.loading)
                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                        key: 1,
                        indeterminate: ""
                      }))
                    : _createCommentVNode("", true),
                  (newdate.status === _ctx.Status.saved)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 2,
                        color: "success",
                        icon: "mdi:mdi-content-save-check-outline"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_tooltip, {
                    start: "",
                    text: "tooltip"
                  }, {
                    activator: _withCtx(({ props }) => [
                      (newdate.status === _ctx.Status.error)
                        ? (_openBlock(), _createBlock(_component_v_icon, _mergeProps({
                            key: 0,
                            icon: "mdi:mdi-alert-circle-outline",
                            color: "error",
                            ref_for: true
                          }, props), null, 16))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(newdate.error), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              }), 256))
            ])
          ]),
          (_ctx.newDates && _ctx.newDates.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Aantal dagen: " + _toDisplayString(_ctx.newDates.length), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_v_btn, {
            color: "success",
            disabled: !_ctx.newDates || _ctx.newDates.filter((d) => d.status !== 'saved' && d.status !== 'loading').length === 0,
            class: "mt-4",
            block: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialog = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Opslaan in AFAS ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialog) = $event)),
      width: "500px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.projects && _ctx.projects.length > 0 && !_ctx.fromProject)
                    ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                        key: 0,
                        label: "Kies project",
                        items: _ctx.projects,
                        disabled: !_ctx.projects,
                        "item-title": "Projectomschrijving",
                        "item-value": "ProjectCode",
                        "onUpdate:modelValue": _ctx.onChangeProject
                      }, null, 8, ["items", "disabled", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true),
                  (_ctx.employees && _ctx.employees.length > 0 && _ctx.fromProject)
                    ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                        key: 1,
                        label: "Kies medewerker",
                        items: _ctx.employees,
                        disabled: !_ctx.employees,
                        "item-title": "Naam",
                        "item-value": "Medewerker",
                        "onUpdate:modelValue": _ctx.onChangeEmployee
                      }, null, 8, ["items", "disabled", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true),
                  (_ctx.useProjectFase)
                    ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                        key: 2,
                        label: (!_ctx.projectFases || _ctx.projectFases.length === 0) ? 'Geen projectfase' : 'Kies projectfase',
                        items: _ctx.projectFases,
                        disabled: !_ctx.projectFases || _ctx.projectFases.length == 0,
                        "item-title": "Omschrijving",
                        "item-value": "Projectfase",
                        "onUpdate:modelValue": _ctx.onChangeProjectFase
                      }, null, 8, ["label", "items", "disabled", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true),
                  (_ctx.items && _ctx.items.length > 0)
                    ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                        key: 3,
                        label: "Kies itemcode",
                        items: _ctx.items,
                        disabled: !_ctx.items,
                        "item-title": "ItemOmschrijving",
                        "item-value": "Itemcode",
                        "onUpdate:modelValue": _ctx.onChangeItem
                      }, null, 8, ["items", "disabled", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_text_field, {
                    id: "begintime",
                    label: "Begintijd",
                    type: "time",
                    modelValue: _ctx.begintime,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.begintime) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_text_field, {
                    id: "endtime",
                    label: "Eindtijd",
                    type: "time",
                    modelValue: _ctx.endtime,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endtime) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_text_field, {
                    if: "description",
                    label: "Omschrijving",
                    type: "text",
                    modelValue: _ctx.description,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.description) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialog = false)),
                  onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.dialog = false), ["esc"])),
                  tabindex: "-1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Annuleren ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "success",
                  disabled: !_ctx.selectedProject || !_ctx.selectedItem,
                  onClick: _ctx.saveToAFAS
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Opslaan ")
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showDatePopup,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showDatePopup) = $event)),
      width: "60%",
      onKeyup: _cache[11] || (_cache[11] = _withKeys(($event: any) => (_ctx.setShowDatePopup(false)), ["esc"])),
      tabindex: "-1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.datePopupDates.length > 0 
                        ? _ctx.DateTime.fromISO(_ctx.datePopupDates[0]?.Datum).toFormat('yyyy-MM-dd')
                        : _ctx.DateTime.now().toFormat('yyyy-MM-dd')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_table, null, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datePopupDates, (date) => {
                        return (_openBlock(), _createElementBlock("tr", null, [
                          (_ctx.employees && _ctx.employees.length > 0 && _ctx.fromProject)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_10, _toDisplayString(_ctx.employees.find((emp) => emp.Medewerker === date.MedewerkerCode)?.Naam || date.MedewerkerCode), 1))
                            : (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString(date.ProjectOmschrijving) + " - " + _toDisplayString(date.ItemOmschrijving), 1)),
                          _createElementVNode("td", null, _toDisplayString(date.Aantal), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_v_btn, {
                                icon: "mdi-file-edit",
                                color: "light-blue",
                                size: "small",
                                onClick: ($event: any) => (_ctx.openEditNacalc(date)),
                                disabled: _ctx.storeEditLoading
                              }, null, 8, ["onClick", "disabled"]),
                              _createTextVNode("   "),
                              _createVNode(_component_v_btn, {
                                icon: "mdi-delete-alert",
                                color: "red-darken-2",
                                size: "small",
                                onClick: ($event: any) => (_ctx.openDeleteNacalc(date)),
                                disabled: _ctx.storeEditLoading
                              }, null, 8, ["onClick", "disabled"])
                            ])
                          ])
                        ]))
                      }), 256))
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.storeEditLoading)
                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                      key: 0,
                      indeterminate: ""
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  icon: "mdi-plus-circle",
                  color: "green",
                  size: "x-large",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addDate(_ctx.DateTime.fromISO(_ctx.datePopupDates[0]?.Datum))))
                }),
                _createVNode(_component_v_btn, {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setShowDatePopup(false)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Sluiten")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showDeleteNacalcDialogComputed,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.showDeleteNacalcDialogComputed) = $event)),
      width: "40%",
      onKeyup: _cache[14] || (_cache[14] = _withKeys(($event: any) => (_ctx.showDeleteNacalcDialog = false), ["esc"])),
      tabindex: "-1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Verwijderen")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Weet je zeker dat je de nacalculatieregel wilt verwijderen?"),
                _hoisted_13,
                (_ctx.storeEditLoading)
                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                      key: 0,
                      indeterminate: ""
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, [
                  _createTextVNode(" Datum: " + _toDisplayString(_ctx.DateTime.fromISO(_ctx.nacalcToEdit.Datum).toFormat("yyyy-MM-dd")), 1),
                  _hoisted_14,
                  _createTextVNode(" Project: " + _toDisplayString(_ctx.nacalcToEdit.ProjectOmschrijving), 1),
                  _hoisted_15,
                  _createTextVNode(" Item: " + _toDisplayString(_ctx.nacalcToEdit.ItemOmschrijving), 1),
                  _hoisted_16,
                  _createTextVNode(" Aantal uur: " + _toDisplayString(_ctx.nacalcToEdit.Aantal), 1),
                  _hoisted_17
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                (_ctx.storeEditLoading)
                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                      key: 0,
                      indeterminate: ""
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_btn, {
                  onClick: _ctx.deleteNacalc,
                  color: "red"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Verwijderen")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_btn, {
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showDeleteNacalcDialog = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Annuleren")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showUpdateNacalcDialogComputed,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.showUpdateNacalcDialogComputed) = $event)),
      width: "60%",
      onKeyup: _cache[24] || (_cache[24] = _withKeys(($event: any) => (_ctx.setShowNacalcUpdatePopup(false)), ["esc"])),
      tabindex: "-1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Aanpassen")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (_ctx.projects && _ctx.projects.length > 0 && !_ctx.fromProject)
                  ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                      key: 0,
                      label: "Kies project",
                      items: _ctx.projects,
                      disabled: !_ctx.projects,
                      "item-title": "Projectomschrijving",
                      "item-value": "ProjectCode",
                      "model-value": _ctx.nacalcToEdit.ProjectId,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.nacalcToEdit.ProjectId) = $event))
                    }, null, 8, ["items", "disabled", "model-value"]))
                  : _createCommentVNode("", true),
                (_ctx.employees && _ctx.employees.length > 0 && _ctx.fromProject)
                  ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                      key: 1,
                      label: "Kies medewerker",
                      items: _ctx.employees,
                      disabled: !_ctx.employees,
                      "item-title": "Naam",
                      "item-value": "Medewerker",
                      "model-value": _ctx.nacalcToEdit.MedewerkerCode,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.nacalcToEdit.MedewerkerCode) = $event))
                    }, null, 8, ["items", "disabled", "model-value"]))
                  : _createCommentVNode("", true),
                (_ctx.useProjectFase)
                  ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                      key: 2,
                      label: (!_ctx.projectFases || _ctx.projectFases.length === 0) ? 'Geen projectfase' : 'Kies projectfase',
                      items: _ctx.projectFases,
                      disabled: !_ctx.projectFases || _ctx.projectFases.length == 0,
                      "item-title": "Omschrijving",
                      "item-value": "Projectfase",
                      "model-value": _ctx.nacalcToEdit.Projectfase,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.nacalcToEdit.Projectfase) = $event))
                    }, null, 8, ["label", "items", "disabled", "model-value"]))
                  : _createCommentVNode("", true),
                (_ctx.items && _ctx.items.length > 0)
                  ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                      key: 3,
                      label: "Kies itemcode",
                      items: _ctx.items,
                      disabled: !_ctx.items,
                      "item-title": "ItemOmschrijving",
                      "item-value": "Itemcode",
                      "model-value": _ctx.nacalcToEdit.Itemcode,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.nacalcToEdit.Itemcode) = $event))
                    }, null, 8, ["items", "disabled", "model-value"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_text_field, {
                  id: "begintime",
                  label: "Begintijd",
                  type: "time",
                  modelValue: _ctx.nacalcToEdit.Begintijd,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.nacalcToEdit.Begintijd) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  id: "endtime",
                  label: "Eindtijd",
                  type: "time",
                  modelValue: _ctx.nacalcToEdit.Eindtijd,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.nacalcToEdit.Eindtijd) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  if: "description",
                  label: "Omschrijving",
                  type: "text",
                  modelValue: _ctx.nacalcToEdit.Omschrijving,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.nacalcToEdit.Omschrijving) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                (_ctx.storeEditLoading)
                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                      key: 0,
                      indeterminate: ""
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_btn, {
                  onClick: _ctx.updateNacalc,
                  color: "green"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Opslaan")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_btn, {
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.setShowNacalcUpdatePopup(false)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Annuleren")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showOTPCodeDialog,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.showOTPCodeDialog) = $event)),
      width: "60%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("OTP code invoeren")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _hoisted_18,
                _createVNode(_component_v_text_field, {
                  if: "description",
                  label: "Activatiecode",
                  type: "text",
                  modelValue: _ctx.otpcode,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.otpcode) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                (_ctx.storeEditLoading)
                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                      key: 0,
                      indeterminate: ""
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_btn, {
                  onClick: _ctx.sendOTPCode,
                  color: "green"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Activeren")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showDetacheringsDialog,
      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.showDetacheringsDialog) = $event)),
      width: "500px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Dagen Selecteren")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "6" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          label: "Van",
                          type: "date",
                          modelValue: _ctx.detacheringForm.from,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.detacheringForm.from) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "6" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          label: "Tot",
                          type: "date",
                          modelValue: _ctx.detacheringForm.to,
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.detacheringForm.to) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _hoisted_19,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (day, idx) => {
                  return (_openBlock(), _createBlock(_component_v_checkbox, {
                    key: idx,
                    modelValue: _ctx.detacheringForm.days,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.detacheringForm.days) = $event)),
                    label: day.label,
                    value: day.value,
                    "hide-details": "",
                    density: "compact"
                  }, null, 8, ["modelValue", "label", "value"]))
                }), 128)),
                _hoisted_20,
                _createVNode(_component_v_checkbox, {
                  modelValue: _ctx.detacheringForm.skipClosed,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.detacheringForm.skipClosed) = $event)),
                  label: "Niet genereren op sluitingsdagen",
                  "hide-details": "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_checkbox, {
                  modelValue: _ctx.detacheringForm.skipBooked,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.detacheringForm.skipBooked) = $event)),
                  label: "Niet genereren op reeds geboekte dagen",
                  "hide-details": "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  label: "Stoppen na aantal dagen",
                  type: "number",
                  modelValue: _ctx.detacheringForm.maxDays,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.detacheringForm.maxDays) = $event)),
                  modelModifiers: { number: true },
                  min: "1",
                  "hide-details": "",
                  density: "compact"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.showDetacheringsDialog = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Annuleren")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "success",
                  onClick: _ctx.generateDays
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Selecteren")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_openBlock(), _createBlock(_component_v_snackbar, {
      modelValue: _ctx.showErrorSnackbar,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.showErrorSnackbar) = $event)),
      location: "top left",
      timeout: 2000,
      color: "error",
      style: {"z-index":"99999"},
      elevation: "24",
      key: _ctx.stateErrorId
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.stateErrorMessage), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.showSnackbar,
      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.showSnackbar) = $event))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.deleteOrUpdateError) + " ", 1),
        _createElementVNode("template", null, [
          _createVNode(_component_v_btn, {
            color: "red",
            variant: "text",
            onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.setSnackbar(false)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Sluiten")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showProjectFilterDialog,
      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.showProjectFilterDialog) = $event)),
      width: "40%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Filter op project")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_autocomplete, {
                  label: "Kies project",
                  items: _ctx.projects,
                  "item-title": "Projectomschrijving",
                  "item-value": "ProjectCode",
                  modelValue: _ctx.selectedProjectFilter,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.selectedProjectFilter) = $event))
                }, null, 8, ["items", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.showProjectFilterDialog = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Annuleren")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  onClick: _ctx.applyProjectFilter,
                  color: "primary",
                  disabled: !_ctx.selectedProjectFilter
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Toepassen")
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}